import * as React from 'react';
import { connect } from 'react-redux';
import '../css/SuperUserPageView.css';
import { TooltipCont } from '../../../infrastructure/tooltips';
import { getScrollbarWidth } from '../../../lib/helpers';
import {CoverDocumentType} from '../../../infrastructure/CoverImageTypes';
import {ICoverImage, ProductLine} from '../../../infrastructure/interfaces'
import {createCover, deleteCover} from '../../../actions/actions'
import HeaderBar from '../../HeaderBar/HeaderBar';
import DeleteConfirmModal from '../../Modals/DeleteConfirmModal';
import { contentImagesRelativePath } from '../../../constants';
import CoverCreatorModal from '../../Modals/CoverCreatorModal/CoverCreatorModal'

export interface IManageCoversProps {
  coverImages?: ICoverImage[];
  createCover(coverImageName: string, coverImageType: ProductLine, coverDocumentType: CoverDocumentType, formData: FormData): void;
  deleteCover(cover: ICoverImage): void;
}

export interface IManageCoversState {
    showCreateModel: boolean;
    showDeleteCoverModal: boolean;
    selectedCover?: ICoverImage;
}

const mapStateToProps = (state: any) => {
  return {
    coverImages: state.wizard.coverImages,
  };
};

const mapDispatchToProps = (dispatch: any): any => {
  return {
    createCover: (coverImageName: string, coverImageType: ProductLine, coverDocumentType: CoverDocumentType, formData: FormData) => {
      dispatch(createCover(coverImageName, coverImageType, coverDocumentType, formData));
    },
    deleteCover: (cover: ICoverImage) => {
      dispatch(deleteCover(cover));
    },
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class ProductsTable extends React.Component<IManageCoversProps, IManageCoversState> {
  tableRow: HTMLElement;
  constructor(props: IManageCoversProps) {
    super(props);
    this.state = {
      showCreateModel: false,
      showDeleteCoverModal: false,
    };
  }

  onCreateCoverRequest() {
    this.setState({
        showCreateModel: true,
        showDeleteCoverModal: false,
        selectedCover: undefined,
    });
  }

  onDeleteCoverRequest(cover: ICoverImage) {
    if(cover.id) {
      this.setState({
          showCreateModel: false,
          showDeleteCoverModal: true,
          selectedCover: cover,
      });
    }
  }

  deleteCover(cover: ICoverImage) {
    this.props.deleteCover(cover);
  }

  closeModals() {

    this.setState({
      showCreateModel: false,
      showDeleteCoverModal: false,
      selectedCover: undefined,
    });
  }

  render() {

    const {
      coverImages,
    } = this.props;
    var nonNullCoverImages = coverImages ? coverImages : [];

    return (
      <div className="root-container">
        <HeaderBar />
        <div className="inner-su-container">
          <div className="manage-items-row-offsetRight">

            <div className="in-row-text-container">
              Manage Cover Images
            </div>

            <div className="in-row-button-container">

              <button
                className="btn primary-green large"
                onClick={() => {this.onCreateCoverRequest();}}
                title={TooltipCont.CREATE_COVER}
              >
                Create New Cover Image
              </button>
          </div>
          </div>
          <table className="table-scrollableSU documents-table">
            <thead style={{ paddingRight: getScrollbarWidth() }}>
              <tr>
                <th>Thumbnail</th>
                <th>Actions</th>
                <th>Name</th>
              </tr>
            </thead>
            <tbody className="document-table-body">
              {nonNullCoverImages.map((coverImage: ICoverImage) =>
                <tr key={coverImage.id} ref={tr => this.tableRow = tr!}>
                  <td>
                    <img className="inlineImagesTableImage" src={contentImagesRelativePath + coverImage.web.fullCover} />
                  </td>
                  <td>
                    <button
                      className="btn primary-red"
                      onClick={() => this.onDeleteCoverRequest(coverImage)}
                      title={TooltipCont.DELETE}
                      disabled={false}
                    >
                      Delete
                    </button>
                  </td>
                    <td>{coverImage.title}</td>
                </tr>)}
            </tbody>
          </table>

          <CoverCreatorModal
              show={this.state.showCreateModel}
              onClose={() => this.closeModals()}
              onSubmit={(coverImageName: string, coverImageType: ProductLine, coverDocumentType: CoverDocumentType, formData: FormData) => {
                  this.closeModals();
                  this.props.createCover(coverImageName, coverImageType, coverDocumentType, formData);
                }
              }
          />

          <DeleteConfirmModal
              show={this.state.showDeleteCoverModal}
              onClose={() => this.closeModals()}
              onSave={() => {
                  if(this.state.selectedCover && this.state.selectedCover.id) {
                    this.deleteCover(this.state.selectedCover);
                  }
                  this.closeModals();
              }}
              title={(this.state.selectedCover)
                ? 'Delete Cover "' + this.state.selectedCover.title + '"?'
                : 'Error. Please go back.'}
          />
        </div>
      </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/SuperUser/components/ManageCovers.tsx